// extracted by mini-css-extract-plugin
module.exports = {"disclaimer_con":"index_disclaimer_con__nM5oj","oneCon":"index_oneCon__2Tg0e"};